import DataMap from '../../components/DataMap/DataMap';
import DataTable from '../../components/DataTable/DataTable';
import { Icon } from 'leaflet';
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { getModalDataForManagement } from '../../Helpers/fetchDevices';
import {useDeviceManagement} from '../../hooks/useDeviceManagement';

const customIcon = new Icon({
    iconUrl : require('../../components/DataMap/assets/marker.png'),
    iconSize: [38,38]
})

const dataColumns = [
    {label: "Όνομα Συσκευής", key: "name"},
    {label: "Αριθμός Συσκευής", key: "uid"},
    {label: "Longtitude", key: "lat"},
    {label: "Longtitude", key: "lon"},
    {label: "Κατασκευαστής", key: "manufacturer"},
    {label: "Τύπος Φωτιστικού", key: "type"},
    {label: "Διευθυνση", key: "address"},
];

const DeviceManagement = () => {
    const {devices, page,
        rowsPerPage,
        totalCount,
        devicesForTable,
        handleChangePage,
        handleChangeRowsPerPage,
        addDevice,
        updateDevice,
        deleteDevice, } = useDeviceManagement();
    return (
  <Grid container spacing={22}>

    <Grid item xs={12} md={6}>
      <Box sx={{ height: { xs: '75vh', md: '100%' } }}>
        <DataMap
          markers={devices}
          deviceType="manage"
          customIcon={customIcon}
          modalFetcher={getModalDataForManagement}
          addDevice={addDevice}
          updateDevice={updateDevice}
          deleteDevice={deleteDevice}
        />
      </Box>
    </Grid>

    <Grid item xs={12} md={6}>
      <Box sx={{ width: '100%' }}>
        <DataTable
          columns={dataColumns}
          data={devicesForTable}
          page={page}
          rowsPerPage={rowsPerPage}
          totalCount={totalCount}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Box>
    </Grid>
  </Grid>
);
}

export default DeviceManagement;